<template lang="pug" src="./block-doctor.pug"></template>

<script>

export default {
  data () {
    return {
      active: false,
      show: 0,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.3]
      }
    }
  },
  props: {
    props: {
      Type: Object
    },
    reverse: {
      Type: Boolean,
      default: false
    },
    id: {
      Type: String,
      default: ''
    }
  },
  methods: {
    onScroll ({going, direction}) {
      if (going === 'in') {
        this.active = true
      }
    },
    handleClick (i) {
      this.show = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/block/block-doctor/block-doctor.vue